var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckPattern(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 768,
    height: 768,
    viewBox: "0 0 768 768",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9105_57354",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 768,
    height: 768
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 768,
    height: 768,
    fill: "url(#paint0_radial_9105_57354)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9105_57354)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9105_57354)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_9105_57354)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    x2: 0.5,
    y2: 768,
    stroke: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 48.5,
    x2: 48.5,
    y2: 768,
    stroke: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 96.5,
    x2: 96.5,
    y2: 768,
    stroke: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 144.5,
    x2: 144.5,
    y2: 768,
    stroke: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 192.5,
    x2: 192.5,
    y2: 768,
    stroke: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 240.5,
    x2: 240.5,
    y2: 768,
    stroke: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 288.5,
    x2: 288.5,
    y2: 768,
    stroke: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 336.5,
    x2: 336.5,
    y2: 768,
    stroke: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 384.5,
    x2: 384.5,
    y2: 768,
    stroke: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 432.5,
    x2: 432.5,
    y2: 768,
    stroke: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480.5,
    x2: 480.5,
    y2: 768,
    stroke: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 528.5,
    x2: 528.5,
    y2: 768,
    stroke: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 576.5,
    x2: 576.5,
    y2: 768,
    stroke: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 624.5,
    x2: 624.5,
    y2: 768,
    stroke: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 672.5,
    x2: 672.5,
    y2: 768,
    stroke: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 720.5,
    x2: 720.5,
    y2: 768,
    stroke: "#E4E7EC"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 767,
    height: 767,
    stroke: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_9105_57354)"
  }, /*#__PURE__*/React.createElement("line", {
    y1: 47.5,
    x2: 768,
    y2: 47.5,
    stroke: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("line", {
    y1: 95.5,
    x2: 768,
    y2: 95.5,
    stroke: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("line", {
    y1: 143.5,
    x2: 768,
    y2: 143.5,
    stroke: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("line", {
    y1: 191.5,
    x2: 768,
    y2: 191.5,
    stroke: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("line", {
    y1: 239.5,
    x2: 768,
    y2: 239.5,
    stroke: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("line", {
    y1: 287.5,
    x2: 768,
    y2: 287.5,
    stroke: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("line", {
    y1: 335.5,
    x2: 768,
    y2: 335.5,
    stroke: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("line", {
    y1: 383.5,
    x2: 768,
    y2: 383.5,
    stroke: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("line", {
    y1: 431.5,
    x2: 768,
    y2: 431.5,
    stroke: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("line", {
    y1: 479.5,
    x2: 768,
    y2: 479.5,
    stroke: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("line", {
    y1: 527.5,
    x2: 768,
    y2: 527.5,
    stroke: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("line", {
    y1: 575.5,
    x2: 768,
    y2: 575.5,
    stroke: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("line", {
    y1: 623.5,
    x2: 768,
    y2: 623.5,
    stroke: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("line", {
    y1: 671.5,
    x2: 768,
    y2: 671.5,
    stroke: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("line", {
    y1: 719.5,
    x2: 768,
    y2: 719.5,
    stroke: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("line", {
    y1: 767.5,
    x2: 768,
    y2: 767.5,
    stroke: "#E4E7EC"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 767,
    height: 767,
    stroke: "#E4E7EC"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_9105_57354",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(384 384) rotate(90) scale(384 384)"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9105_57354"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 768,
    height: 768,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_9105_57354"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 768,
    height: 768,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_9105_57354"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 768,
    height: 768,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckPattern);
export default __webpack_public_path__ + "static/media/checkPattern.76105fa5e610b9df5986332e2cf4ccd4.svg";
export { ForwardRef as ReactComponent };